// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3gsY3","colCheckbox":"styles_colCheckbox__C9TO5"};